import { skipToken } from '@reduxjs/toolkit/query';
import { DateFormats, formatDate } from '@strata/helper-functions';
import { FormSection } from '@strata/react-form-section';
import { ColumnDef, Grid, SecondaryData } from '@strata/react-grid';
import { Spinner } from '@strata/react-loading-animation';

import {
    AutomationChangeTypes,
    AutomationRuleHistory,
    useGetAutomationRuleHistoryQuery,
} from 'store/api/performanceApi';

const ChangeTypeDisplayTextMap = {
    [AutomationChangeTypes.ADDED]: 'Added',
    [AutomationChangeTypes.DELETED]: 'Deleted',
    [AutomationChangeTypes.TURNED_ON]: 'Turned On',
    [AutomationChangeTypes.TURNED_OFF]: 'Turned Off',
    [AutomationChangeTypes.CHANGED]: 'Changed',
};

const initialSortProperties = [{ id: 'timestamp', desc: true }];

const columns: ColumnDef<AutomationRuleHistory>[] = [
    {
        accessorKey: 'timestamp',
        header: 'Updated On',
        size: 110,
        cell: ({ getValue }) => (
            <SecondaryData data={formatDate(getValue(), DateFormats.DATE_TIME)} />
        ),
    },
    {
        accessorKey: 'username',
        header: 'User',
        size: 130,
    },
    {
        accessorKey: 'changeType',
        header: 'Change',
        size: 95,
        cell: ({ getValue }) => <SecondaryData data={ChangeTypeDisplayTextMap[getValue()]} />,
    },
];

interface RuleHistoryProps {
    rule?: { id?: string };
}

export const RuleHistory = ({ rule = undefined }: RuleHistoryProps) => {
    const { data: ruleHistory, isFetching } = useGetAutomationRuleHistoryQuery(
        rule?.id ?? skipToken,
    );

    return (
        <div className="sds_automations__column-section--expand">
            <FormSection
                sectionTitle="History"
                content={
                    isFetching ? (
                        <Spinner intent={Spinner.Intent.PRIMARY} />
                    ) : (
                        <Grid
                            data={ruleHistory}
                            sortProperties={initialSortProperties}
                            noResults={
                                <span className="sds_label font-bold--uppercase">
                                    No Updates Found
                                </span>
                            }
                            columns={columns}
                        />
                    )
                }
            />
        </div>
    );
};
